import React, { useEffect, useState, useRef } from 'react';
import SvgChart from './SvgChart'
import useSharedAnimation from '../plugins/useSharedAnimation';
import { colorByType, dataCountByType, dataFullbyType, dataCountPerFrameByType, colorByPriority, speedStringByType } from '../plugins/common';

//recoil
import { useRecoilState } from 'recoil';
import { globalParameterColorState, measurementStateFamily} from "../plugins/recoil";

const ChartWrapper = ({ type, data, bedInfo, settingStatus, isPlaying, isFirst = false, hideType = false, isPlayer, isDetecting, isShowECGPacer, curSec, isDisconnected, isBedNumberBig, chartCount, viewType, speed, handleBufferCount }) => {
    const hrDataArr = [15,24,29,-6,1,7,36,38,42,44,43,43,36,31,23,14,9,-3,-7,-10,-10,-10,-10,-10,-10,-10,-9,-9,-9,-10,-10,-10,-9,-9,-9,-9,-9,-9,-9,-9,-9,-9,-9,-9,-9,-9,-9,-9,-9,-8,-7,-1,-5,-2,17,14,4,7,15,7,-7,-7,-3,-8,-8,-9,-8,-8,-9,-9,-9,-9,-9,-9,-9,-9,-9,-9,-9,-9,-10,-9,-9,-9,-9,-9,-10,-10,-9,-8,-9,-8,-8,-9,-9,-8,-9,-8,-10,-15,-15,5,103,116,60,19,-21,-7,-9,-8,-14,-8,-10,-9,-9,-9,-9,-9,-9,-8,-9,-8,-8,-7,0, 'P', 15,24,29,-6,1,7,36,38,42,44,43,43,36,31,23,14,9,-3,-7,-10,-10,-10,-10,-10,-10,-10,-9,-9,-9,-10,-10,-10,-9,-9,-9,-9,-9,-9,-9,-9,-9,-9,-9,-9,-9,-9,-9,-9,-9,-8,-7,-1,-5,-2,17,14,4,7,15,7,-7,-7,-3,-8,-8,-9,-8,-8,-9,-9,-9,-9,-9,-9,-9,-9,-9,-9,-9,-9,-10,-9,-9,-9,-9,-9,-10,-10,-9,-8,-9,-8,-8,-9,-9,-8,-9,-8,-10,-15,-15,5,103,116,60,19,-21,-7,-9,-8,-14,-8,-10,-9,-9,-9,-9,-9,-9,-8,-9,-8,-8,-7,0, 'P', 15,24,29,-6,1,7,36,38,42,44,43,43,36,31,23,14,9,-3,-7,-10,-10,-10,-10,-10,-10,-10,-9,-9,-9,-10,-10,-10,-9,-9,-9,-9,-9,-9,-9,-9,-9,-9,-9,-9,-9,-9,-9,-9,-9,-8,-7,-1,-5,-2,17,14,4,7,15,7,-7,-7,-3,-8,-8,-9,-8,-8,-9,-9,-9,-9,-9,-9,-9,-9,-9,-9,-9,-9,-10,-9,-9,-9,-9,-9,-10,-10,-9,-8,-9,-8,-8,-9,-9,-8,-9,-8,-10,-15,-15,5,103,116,60,19,-21,-7,-9,-8,-14,-8,-10,-9,-9,-9,-9,-9,-9,-8,-9,-8,-8,-7,0, 'P', 15,24,29,-6,1,7,36,38,42,44,43,43,36,31,23,14,9,-3,-7,-10,-10,-10,-10,-10,-10,-10,-9,-9,-9,-10,-10,-10,-9,-9,-9,-9,-9,-9,-9,-9,-9,-9,-9,-9,-9,-9,-9,-9,-9,-8,-7,-1,-5,-2,17,14,4,7,15,7,-7,-7,-3,-8,-8,-9,-8,-8,-9,-9,-9,-9,-9,-9,-9,-9,-9,-9,-9,-9,-10,-9,-9,-9,-9,-9,-10,-10,-9,-8,-9,-8,-8,-9,-9,-8,-9,-8,-10,-15,-15,5,103,116,60,19,-21,-7,-9,-8,-14,-8,-10,-9,-9,-9,-9,-9,-9,-8,-9,-8,-8,-7,0, 'P']
    // const hrDataArr = [15,24,29,-6,1,7,36,38,42,44,43,43,36,31,23,14,9,-3,-7,-10,-10,-10,-10,-10,-10,-10,-9,-9,-9,-10,-10,-10,-9,-9,-9,-9,-9,-9,-9,-9,-9,-9,-9,-9,-9,-9,-9,-9,-9,-8,-7,-1,-5,-2,17,14,4,7,15,7,-7,-7,-3,-8,-8,-9,-8,-8,-9,-9,-9,-9,-9,-9,-9,-9,-9,-9,-9,-9,-10,-9,-9,-9,-9,-9,-10,-10,-9,-8,-9,-8,-8,-9,-9,-8,-9,-8,-10,-15,-15,5,103,116,60,19,-21,-7,-9,-8,-14,-8,-10,-9,-9,-9,-9,-9,-9,-8,-9,-8,-8,-7,0]
    const chartWrapperRef = useRef(null)
    const [dataCountPerFrame, setDataCountPerFrame] = useState(dataCountPerFrameByType[type] || 10);
    const [dataSpeed, setDataSpeed] = useState(1000 / ((dataCountByType[type] || 250) / dataCountPerFrame)); // Frame
    const [dataCount, setDataCount] = useState(dataFullbyType(isBedNumberBig, type, viewType));
    const [parameterColors, ] = useRecoilState(globalParameterColorState);
    const [measurementSettings, setMeasurementSettings] = useRecoilState(measurementStateFamily(bedInfo.serial))
    const intervalRef = useRef(null)
    // const animateIndex = 0;

    // useSharedAnimation 훅 사용
    const animateIndex = useSharedAnimation(
        (index) => {},
        dataSpeed,
        dataCount,
        dataCountPerFrame,
        isPlayer,
        isPlaying,
        curSec,
    );

    useEffect(() => {
        if (isPlayer) return;
        if (measurementSettings[speedStringByType[type]]) {
            const newSpeed = parseFloat(measurementSettings[speedStringByType[type]])
            const newCount = parseInt(dataFullbyType(isBedNumberBig, type, viewType) * 25 / newSpeed)
            if (newCount !== dataCount) {
                setDataCount(newCount)
            }
        }
    }, [measurementSettings])

    useEffect(() => {
        if (isPlayer) {
            const newCount = parseInt(dataFullbyType(isBedNumberBig, type, viewType) * 25 / speed)
            if (newCount !== dataCount) {
                setDataCount(newCount)
            }
        }
    }, [isPlayer, speed])

    useEffect(() => {                
        // setDataCount(dataFullbyType(isBedNumberBig, type, viewType))
        setDataCountPerFrame(dataCountPerFrameByType[type] || 10)
    }, [type])

    const backgroundColor = 'transparent';

    return (
        <>
            <div className="flex-1" style={{ width: '100%', height: `${100 / chartCount}%`, backgroundColor: backgroundColor, color: 'white' }}>
                <div ref={chartWrapperRef} className="" style={{ width: '100%', height: '100%', position: 'relative', overflow: 'hidden' }}>
                    <SvgChart
                        intervalIndex={animateIndex}
                        type={type}
                        data={data}
                        isFirst={isFirst}
                        isPlayer={isPlayer}
                        isPlaying={isPlaying}
                        isShowECGPacer={isShowECGPacer}
                        isDetecting={isDetecting}
                        bedInfo={bedInfo}
                        curSec={curSec}
                        width={chartWrapperRef.current?.clientWidth}
                        height={chartWrapperRef.current?.clientHeight}                        
                        stroke={parameterColors.waveParameterColors[type]}
                        count={dataCount}
                        bufferCount={3}
                        bufferMaxCount={4}
                        viewType={viewType}
                        componentId={`${isPlayer ? 'player_' + type + '_' : ''}${bedInfo?.serial || 'demo'}_${type}`}
                        dataCountPerFrame={dataCountPerFrame}
                        handleBufferCount={handleBufferCount}
                    />
                    {/* <div style={{ top: 0, height: '100%', width: 10, left: `${(100 / (dataCount)) * animateIndex}%`, backgroundColor: 'rgba(0, 0, 0, 1)', position: 'absolute' }} /> */}
                    <div className="absolute flex px-4" style={{ fontFamily: 'Roboto', top: 0, left: 0, width: '100%', height: '100%', paddingTop: viewType < 32 ? 8 : 0, paddingBottom: viewType < 32 ? 8 : 0 }}>
                        {
                            hideType ? null :
                            ['IBP1', 'IBP2', 'IBP3', 'IBP4'].indexOf(type) !== -1 ?                            
                            <div className="w-[100px]" style={{ color: parameterColors.waveParameterColors[type] }}>{settingStatus[`${type.toLowerCase()}Label`] ? settingStatus[`${type.toLowerCase()}Label`] : type}</div>
                            :                            
                            <div className="w-[100px]" style={{ color: parameterColors.waveParameterColors[type] }}>{type}</div>
                        }
                    </div>
                </div>
            </div>
        </>
    );
};

export default ChartWrapper;